"use client";

import { BaseModal } from "@/components/ui/modal";
import { LogOut } from "lucide-react";
import { prepareSignOut } from "@/lib/analytics/posthog";

type ConfirmLogoutModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

export function ConfirmLogoutModal({
  isOpen,
  onClose,
  onConfirm,
}: ConfirmLogoutModalProps) {
  return (
    <BaseModal
      isOpen={isOpen}
      onClose={onClose}
      maxWidth="max-w-[380px]"
      closeOnBackdrop={true}
    >
      <div className="space-y-5 py-2">
        <div>
          <h3 className="text-lg font-semibold text-[#c7d5e0]">
            Sign out
          </h3>
          <p className="text-sm text-[#8f98a0] mt-1">
            Are you sure you want to sign out?
          </p>
        </div>
        <div className="flex gap-3 justify-end">
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 rounded-lg text-sm font-medium text-[#c7d5e0] border border-[#2a475e]/70 bg-[#1b2838]/80 hover:bg-[#1f2e3f] hover:border-[#3a556e] transition-colors"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={async () => {
              onClose();
              // The sign-out itself is a form post + full navigation, so the
              // browser client never sees SIGNED_OUT: report it and reset the
              // analytics identity first (bounded wait, never throws). The
              // form submit after an await is fine — it needs no user gesture.
              await prepareSignOut();
              onConfirm();
            }}
            className="inline-flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium text-white bg-red-600 hover:bg-red-500 transition-colors"
          >
            <LogOut className="w-4 h-4" />
            Sign out
          </button>
        </div>
      </div>
    </BaseModal>
  );
}
